import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent } from '@/components/feature/solution/theme';

interface SceneItem {
  id: string;
  icon: string;
  title: string;
  image: string;
  alt: string;
  badge?: string;
  points: string[];
}

interface SceneData {
  eyebrow: string;
  title: string;
  subtitle: string;
  items: SceneItem[];
}

export default function LogisticsScenarios({ data }: { data: SceneData }) {
  const a = accent('green');

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex justify-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold tracking-wide whitespace-nowrap">
            <i className="ri-map-2-line"></i>
            {data.eyebrow}
          </span>
        </div>
        <div className="mt-4">
          <SectionHeading title={data.title} subtitle={data.subtitle} />
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.items.map((s, idx) => (
            <Reveal key={s.id} delay={idx * 60}>
              <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100">
                <div className="relative w-full h-44 md:h-48 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.alt}
                    title={s.alt}
                    className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.06]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/15 to-transparent"></div>
                  {s.badge && (
                    <span className="absolute top-4 right-4 px-2.5 py-1 rounded-full bg-accent-500 text-foreground-950 text-[11px] font-semibold whitespace-nowrap">
                      {s.badge}
                    </span>
                  )}
                  <div className="absolute inset-x-0 bottom-0 p-5 flex items-center gap-3">
                    <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-background-50/95 text-accent-700">
                      <i className={`${s.icon} text-xl`}></i>
                    </span>
                    <h3 className="font-heading font-bold text-background-50 text-base md:text-lg leading-snug">
                      {s.title}
                    </h3>
                  </div>
                </div>

                <ul className="p-5 md:p-6 flex flex-col gap-3">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-2.5">
                      <span className={`w-5 h-5 shrink-0 mt-0.5 flex items-center justify-center rounded-full ${a.iconBox}`}>
                        <i className="ri-check-line text-xs"></i>
                      </span>
                      <span className="text-sm text-foreground-700 leading-relaxed">{p}</span>
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}